{
  "list": {
    "title": "กล่องข้อความ",
    "loadFailed": "ไม่สามารถโหลดรายการสนทนาได้",
    "searchPlaceholder": "ค้นหา…",
    "needsAttention": "ต้องการความช่วยเหลือ",
    "clearFilters": "เคลียร์ตัวกรอง",
    "tabAll": "ทั้งหมด",
    "tabUnread": "ยังไม่อ่าน",
    "emptyNoConversations": "ไม่มีการสนทนา",
    "emptyNoUnread": "ยังไม่มีข้อความใหม่",
    "emptyNoMatches": "ไม่พบการสนทนาที่ตรงกับตัวกรอง",
    "reauthRequired": "⚠ ต้องเชื่อมต่อใหม่ · ",
    "customerInfoAria": "ข้อมูลลูกค้า",
    "linkUnavailable": "ไม่พบแชทนี้ อาจถูกลบไปแล้วหรือเป็นของร้านอื่น",
    "viaChannel": "ผ่าน {{channel}}"
  },
  "welcome": {
    "title": "ยินดีต้อนรับสู่กล่องข้อความ",
    "body": "เลือกลูกค้าจากรายการด้านซ้ายเพื่อเปิดการสนทนาและเริ่มแชทกับลูกค้าของคุณ",
    "queueTitle": "แชทรอคนตอบ",
    "queueBody": "AI ส่งแชทเหล่านี้มาให้ทีมของคุณ เลือกแชทเพื่อตอบต่อ หรือเลือกจากรายการด้านซ้าย"
  },
  "thread": {
    "backAria": "ย้อนกลับ",
    "customerInfoAria": "ดูข้อมูลลูกค้า",
    "messagesAria": "ข้อความ",
    "loadingMessages": "กำลังโหลดข้อความ…",
    "loadingOlder": "กำลังโหลดข้อความเก่า…",
    "loadOlderFailed": "โหลดข้อความเก่าไม่สำเร็จ",
    "retryLoadOlder": "ลองใหม่",
    "empty": "ยังไม่มีข้อความ",
    "botTag": "AI",
    "sendFailed": "ส่งไม่สำเร็จ",
    "sendMessageFailed": "ส่งข้อความไม่สำเร็จ กรุณาลองใหม่",
    "composerPlaceholder": "พิมพ์ข้อความ…",
    "sendAria": "ส่งข้อความ",
    "imageAlt": "รูปภาพ",
    "stickerAlt": "สติกเกอร์",
    "imageUnavailable": "ไม่สามารถแสดงรูปภาพ",
    "stickerUnavailable": "ไม่สามารถแสดงสติกเกอร์",
    "retryMedia": "ลองใหม่",
    "mediaLoading": "กำลังโหลดรูปภาพ",
    "fileFallback": "ไฟล์แนบ",
    "channelDisabledTitle": "ช่องทางนี้ถูกปิดอยู่",
    "channelDisabledBody": "เปิดใช้งาน {{channel}} ในหน้าตั้งค่าช่องทางเพื่อตอบลูกค้า",
    "channelReauthTitle": "ช่องทางนี้ขาดการเชื่อมต่อ",
    "channelReauthBody": "กรุณาเชื่อมต่อ {{channel}} อีกครั้งเพื่อตอบลูกค้า",
    "goToSettings": "ไปที่ตั้งค่า"
  },
  "window": {
    "minutes": "{{count}} นาที",
    "hoursMinutes": "{{hours}} ชม {{minutes}} นาที",
    "days": "{{count}} วัน",
    "daysHours": "{{days}} วัน {{hours}} ชม.",
    "humanAgentWindow": "ตอบเองเท่านั้น · เหลือ {{remaining}}",
    "humanAgentHint": "เกิน 24 ชั่วโมงของ {{platform}} แล้ว คุณยังตอบเองได้อีก 7 วัน แต่บอทตอบให้ไม่ได้",
    "metaWindowReason": "{{platform}} ไม่อนุญาตให้ตอบหลังจาก 7 วันนับจากข้อความล่าสุดของลูกค้า",
    "metaWindowReasonStandard": "{{platform}} ไม่อนุญาตให้ตอบหลังจาก 24 ชั่วโมงนับจากข้อความล่าสุดของลูกค้า",
    "freeReply": "✓ ตอบฟรี ใน {{remaining}}",
    "unlimited": "ไม่จำกัดข้อความ",
    "remainingThisMonth": "เหลือ {{count}} ข้อความเดือนนี้",
    "usageThisMonth": "{{used}} / {{cap}} ข้อความเดือนนี้",
    "replyWithin": "ตอบได้อีก {{remaining}}",
    "lineQuotaReason": "โควต้า LINE เดือนนี้หมดแล้ว กรุณาอัปเกรดแพ็กเกจ LINE",
    "lineQuotaPlaceholder": "ไม่สามารถส่งข้อความได้ — โควต้าเต็ม",
    "metaWindowPlaceholder": "หมดเวลาตอบกลับ"
  },
  "bot": {
    "label": "บอทตอบอัตโนมัติ",
    "toggleFailed": "เปลี่ยนสถานะบอทไม่สำเร็จ",
    "enabled": "บอทเปิดใช้งานแล้ว",
    "disabled": "บอทหยุดทำงานแล้ว",
    "tooltipActive": "บอทกำลังตอบอัตโนมัติ",
    "tooltipPaused": "บอทหยุดทำงาน — คลิกเพื่อเปิด",
    "unavailable": "ปิดสำหรับ {{platform}}",
    "unavailableLink": "เปิดใช้งาน",
    "unavailableTooltip": "ผู้ช่วย AI ของร้านยังไม่ได้ตอบใน {{platform}} เปิด {{platform}} ได้ที่การตั้งค่าผู้ช่วย AI",
    "pendingAria": "คำสั่งซื้อที่รออนุมัติจากบอท",
    "pendingTitle": "รออนุมัติจากบอท",
    "suggested": "บอทแนะนำ",
    "total": "ยอดรวม",
    "recipient": "ผู้รับ",
    "confirm": "ยืนยัน",
    "reject": "ปฏิเสธ",
    "loadActionsFailed": "ไม่สามารถโหลดรายการอนุมัติได้",
    "approveSuccess": "อนุมัติออเดอร์สำเร็จ",
    "rejectSuccess": "ปฏิเสธออเดอร์แล้ว"
  },
  "customer": {
    "linkTitle": "เชื่อมโยงกับลูกค้า",
    "linkSuccess": "เชื่อมโยงลูกค้าสำเร็จ",
    "linkFailed": "ไม่สามารถเชื่อมโยงลูกค้าได้",
    "unlinkSuccess": "ยกเลิกการเชื่อมโยงสำเร็จ",
    "unlinkFailed": "ไม่สามารถยกเลิกการเชื่อมโยงได้",
    "searchPlaceholder": "ชื่อ • เบอร์ • #แท็ก",
    "searching": "กำลังค้นหา...",
    "notFound": "ไม่พบลูกค้า",
    "cancel": "ยกเลิก",
    "statOrders": "ออเดอร์",
    "statTotal": "ยอดรวม",
    "linkBeforeOrder": "ผูกลูกค้าก่อนสร้างออเดอร์",
    "createOrder": "สร้างออเดอร์",
    "tabProfile": "โปรไฟล์",
    "tabOrders": "ออเดอร์ ({{count}})",
    "tabNotes": "บันทึก",
    "rowEmail": "อีเมล",
    "rowPhone": "โทร",
    "linkToSeeOrders": "ผูกลูกค้าก่อนเพื่อดูออเดอร์",
    "noOrders": "ยังไม่มีออเดอร์",
    "refresh": "รีเฟรช",
    "linkToWriteNotes": "ผูกลูกค้าก่อนเพื่อเขียนบันทึก",
    "notesPlaceholder": "เขียนบันทึกเกี่ยวกับลูกค้านี้ — VIP, ของชอบ, ของแพ้, ฯลฯ",
    "notesSaved": "บันทึกหมายเหตุแล้ว",
    "notesFailed": "บันทึกหมายเหตุไม่สำเร็จ",
    "save": "บันทึก",
    "loadOrdersFailed": "ไม่สามารถโหลดออเดอร์ของลูกค้าได้"
  },
  "order": {
    "title": "ออเดอร์ #{{label}}",
    "summary": "{{count}} รายการ · รวม {{total}}",
    "itemsCount_other": "{{count}} รายการ",
    "view": "ดูออเดอร์",
    "resend": "ส่งให้ลูกค้าอีกครั้ง",
    "resendSuccess": "ส่งให้ลูกค้าอีกครั้งแล้ว",
    "resendNoChat": "ลูกค้ารายนี้ยังไม่มีแชทสำหรับส่งการ์ด",
    "resendFailed": "ส่งใหม่ไม่สำเร็จ",
    "moreLines_other": "และอีก {{count}} รายการ"
  },
  "referral": {
    "ad": "ผ่านโฆษณา FB",
    "link": "ผ่านลิงก์ {{ref}}",
    "source": "ผ่าน {{source}}",
    "detailSource": "ที่มา: {{value}}",
    "detailType": "ประเภท: {{value}}",
    "detailRef": "รหัสอ้างอิง: {{value}}",
    "detailAdId": "รหัสโฆษณา: {{value}}"
  }
}
